import { defineStore } from 'pinia'

type ModalParams = {
  callbackFunction?: () => void;
  [key: string]: unknown;
}

interface IModal {
  id: string | null | undefined
  title?: string | null
  cssClasses?: unknown[]
  params?: ModalParams | null
  scrollbarWidth?: number
}

export const useModalStore = defineStore('modalStore', {
  state: (): IModal => ({
    cssClasses: [],
    scrollbarWidth: 0,
    id: null,
    params: null,
    title: null,
  }),

  actions: {
    openModal(modal: IModal) {
      this.id = modal.id
      this.title = modal.title
      this.params = modal.params
      this.setScrollBar()
    },
    closeModal(withCallbackFunction = false) {
      if (withCallbackFunction) {
        this.callbackFunction()
      }

      this.id = null
      this.title = null
      this.params = null
      this.removeScrollBar()
    },
    shakeModal() {
      this.cssClasses = ['shake']
      setTimeout(() => {
        this.cssClasses = []
      }, 1000)
    },
    setScrollBar() {
      const scrollDiv = document.createElement('div')
      scrollDiv.className = 'modal-scrollbar-measure'
      document.body.append(scrollDiv)
      const scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth
      scrollDiv.remove()

      if (scrollbarWidth > 0) {
        document.body.style.paddingRight = `${scrollbarWidth}px`
      }
      document.body.classList.add('modal-open')
    },
    removeScrollBar() {
      document.body.style.paddingRight = ''
      document.body.classList.remove('modal-open')
    },
    callbackFunction() {
      if (this.params && 'callbackFunction' in this.params) this.params.callbackFunction?.()
    },
  },

  getters: {
    getParams: (state) => state.params,
    getId: (state) => state.id,
    getCssClasses: (state) => state.cssClasses,
    getTitle: (state) => state.title ?? '',
    getMessage: (state) => state.params?.message,
  },
})
